import React, { Fragment } from 'react';
import { shape, string, number } from 'prop-types';
import { MediumSecondaryButton } from '@worthy-npm/clarity';

import RecentDealsSliderMobile from '../common/slider/RecentDealsSliderMobile';
import RecentDealsSliderDesktop from '../common/slider/RecentDealsSliderDesktop';

import { get } from '../../services/api';
import { isMobile, goTo } from '../filters/filter_constants_and_helpers.jsx.erb';

export const ITEMS_COUNT_FOR_SLIDER = 8;

const GA_EVENT_TYPES = {
    similarSoldItemsSliderPresented: {
        action: 'Recent_deals_slider_Presented',
        label: 'Recent deal page'
    },
    similarSoldItemsSliderScrolled: {
        action: 'Recent_deals_slider_Scrolled',
        label: 'Recent deal page'
    },
    similarSoldItemsSliderBtnClicked: {
        action: 'Discover_more_CTA_clicked',
        label: 'Recent deal page'
    },
    similarSoldItemsSliderItemClicked: itemLink => ({
        action: `Recent_deal_clicked`,
        label: itemLink
    }),
};

class SimilarDealItemSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            soldItems: [],
        };

        this.fetchRecentSoldItems = this.fetchRecentSoldItems.bind(this);
    }

    componentDidMount() {
        this._pushGAEvent(GA_EVENT_TYPES.similarSoldItemsSliderPresented);

        this.fetchRecentSoldItems();
    }

    componentDidUpdate(prevProps, prevState) {
        const { soldItems } = this.state;

        if (prevState.soldItems !== soldItems && soldItems.length < ITEMS_COUNT_FOR_SLIDER) {
            this.hideSlider();
        }
    }

    fetchRecentSoldItems() {
        get(`/api/similar_recent_deal?itemId=${this.props.itemId}&limit=${ITEMS_COUNT_FOR_SLIDER}`)
            .then((res) => {
                this.setState({
                   soldItems: [{}, ...res.data.items]
                });
            }).catch(() => {
                console.log('Something went wrong')
            })
    }

    hideSlider() { // method for hiding slider if needed
        const blockRef = document.querySelector('.relatedItems');
        if (!!blockRef.current) {
            blockRef.current.style.display = 'none';
        }
    }

    _pushGAEvent({ action, label }) {
        dataLayer.push({
            'event':'GTM event To GA',
            'GA_event_category': 'Recent_deals_slider',
            'GA_event_action': action,
            'GA_event_label': label
        })
    }

    render() {
        const { soldItems } = this.state;
        const { itemType } = this.props;

        const headerText = ` Similar ${itemType.displayName} ${isMobile() ? '' : 'Auctions'}`;
        const linkToMarketplace = `/about/recent-deals/${itemType.displayName.toLowerCase().replace(' ', '-')}`;

        const sliderProps = {
            showTimeAgo: false,
            soldItems,
            pushClickGAEvent: ({ item_deal_url }) => this._pushGAEvent(GA_EVENT_TYPES.similarSoldItemsSliderItemClicked(item_deal_url)), // deal will be returned
            pushScrollGAEvent: () => this._pushGAEvent(GA_EVENT_TYPES.similarSoldItemsSliderScrolled)
        };

        const renderHeader = () => (
            <a
                href={linkToMarketplace}
                style={{ fontSize: '24px', lineHeight: '26px', color: '#141414', textDecoration: 'none' }}
            >
                { headerText }
            </a>
        );

        return (
            <Fragment>
                <h2 id="recent-deals-title">
                    { renderHeader() }
                </h2>

                {/* Row for slider items */}
                {
                    isMobile()
                        ? <RecentDealsSliderMobile itemsPerSlider={ITEMS_COUNT_FOR_SLIDER} { ...sliderProps } />
                        : <RecentDealsSliderDesktop { ...sliderProps } />
                }

                <div style={{ textAlign: 'center' }}>
                    <button
                        className="underline"
                        onClick={() => {
                            this._pushGAEvent(GA_EVENT_TYPES.similarSoldItemsSliderBtnClicked)
                            goTo(linkToMarketplace);
                        }}
                    >
                        Discover More
                    </button>
                </div>
            </Fragment>
        )
    }
}

SimilarDealItemSlider.propTypes = {
  itemId: number,
  itemType: shape({ // this is according to sold item wich we render now.
      systemName: string,
      displayName: string, // already in plural
  }),
};

export default SimilarDealItemSlider;